// extracted by mini-css-extract-plugin
export var currencyInput = "_js-1";
export var currencySymbol = "_js-0";